import { useEffect, useState } from 'react';
import { useSlate } from 'slate-react';
import { useDebouncedCallback } from 'use-debounce';

import { collectDDVariationFromEditor } from './utils';

const DEBOUNCE_TIMEOUT = 300;

export const useDocumentEditorVariations = (onUpdate) => {
  const editor = useSlate();
  return useEditorVariations(onUpdate, editor);
};

export const useEditorVariations = (onUpdate, editor) => {
  const [editorVariations, setEditorVariations] = useState([]);

  /**
   * Scanning operation runs in debounced mode, not quicker than "DEBOUNCE_TIMEOUT" ms
   */
  const updateVariations = useDebouncedCallback(() => {
    const newVariations = collectDDVariationFromEditor(editor);
    setEditorVariations(newVariations);

    if (onUpdate) {
      onUpdate(newVariations);
    }
  }, DEBOUNCE_TIMEOUT);

  /**
   * Run scan each time something gets changed in editor's DOM
   */
  useEffect(() => {
    updateVariations();
  }, [editor?.children, updateVariations]);

  return editorVariations;
};
